<script setup>
import { computed } from 'ui.vue3';
import { storeToRefs } from 'ui.vue3.pinia';
import useCalculatorStore from '../../../../store/calculator.js';

const calculator = useCalculatorStore();
const { programs, selectedProgram } = storeToRefs(calculator);
const selectedProgramName = computed(() => programs.value.find(p => p.id === selectedProgram.value)?.name);
</script>

<template>
  <p v-if="selectedProgramName"><b>{{ selectedProgramName }}</b></p>
</template>
